export var getDatePortion = function getDatePortion(date) {
  var dateString = new Date(date).toISOString();
  return dateString.slice(0, dateString.indexOf('T'));
};
export var isAfter = function isAfter(comparisonDate, baseDate) {
  var baseDateString = getDatePortion(baseDate);
  var compDateString = getDatePortion(comparisonDate);
  return compDateString > baseDateString;
};
export var isBefore = function isBefore(comparisonDate, baseDate) {
  var baseDateString = getDatePortion(baseDate);
  var compDateString = getDatePortion(comparisonDate);
  return compDateString < baseDateString;
};
export var isSame = function isSame(d1, d2) {
  var date1String = getDatePortion(d1);
  var date2String = getDatePortion(d2);
  return date1String === date2String;
};
export var isSameOrBefore = function isSameOrBefore(comparisonDate, baseDate) {
  return isSame(comparisonDate, baseDate) || isBefore(comparisonDate, baseDate);
};
export var isSameOrAfter = function isSameOrAfter(comparisonDate, baseDate) {
  return isSame(comparisonDate, baseDate) || isAfter(comparisonDate, baseDate);
};
export var getWithAddedDays = function getWithAddedDays(baseDate, days) {
  var date = new Date(baseDate);
  date.setDate(date.getDate() + days);
  return date;
};
export var getWithSubtractedDays = function getWithSubtractedDays(baseDate, days) {
  var date = new Date(baseDate);
  date.setDate(date.getDate() - days);
  return date;
};